'use client';

import { useTranslations } from 'next-intl';

import type { EducationStep } from '@/modules/authentication/view-model';

import { EducationLevelEnum } from '@packages/contracts';
import { Form } from '@packages/hook-form-wrapper';

export const Education = () => {
	const t = useTranslations('authentication.registration.form.educationLevel');
	const options = EducationLevelEnum.options.map(value => ({
		label: t('enum', { educationLevel: value }),
		value,
	}));

	return (
		<Form.RadioGroup<EducationStep> gap={8} name="educationLevel" options={options} />
	);
};
